<template>
    <div class="panel-container collapse show overflow-auto">
        <div class="panel-content">
            <BOverlay :show="is_load">
                
                <div class="panel-tag" v-if="contragent.is_black">
                    <div class="color-danger-600">Контрагент занесений до чорного списку</div>
                    <div class="color-danger-600">
                        {{contragent.black_list.reason }}
                    </div>
                </div>
                
                <company_info_field f_type="Контактна особа" :f_val="this.contragent?.contact_name" />
                <company_info_field f_type="Контактний телефон" :f_val="this.contragent?.contact_tel" />
                <company_info_field f_type="Організація" :f_val="this.contragent?.company" />
                <company_info_field f_type="Email" :f_val="this.contragent?.email" />
                <company_info_field f_type="ЄРДПОУ" :f_val="this.contragent?.edrpou" />
                <company_info_field f_type="Дата реєстрації" :f_val="fmtDate(this.contragent?.registerDate,)" />
                
                <BTabs  v-model:index="tabIndex" v-model="tabId" content-class="mt-3" class=" pt-5">
                    <BTab v-for="(tab,index) in tabs" :disabled="tab.disabled" :id="index" :title="tab.title" :active="tab.is_active" :key="index">
                        <template #title>
                            {{tabTitle(tab)}}
                        </template>
                        <component v-bind:is="tab.index" :contragent="contragent"></component>
                    </BTab>
                </BTabs>
                
            </BOverlay>
        </div>
    </div>
</template>

<script>

import {
    BOverlay,
    BTab,
    BTabs
} from 'bootstrap-vue-next';
import Company_info_field from "./Helpers/company_info_field.vue";

import cont_vkursi from "./tabs/cont_vkursi.vue";
import cont_subscribes from "./tabs/cont_subscribes.vue";
import cont_email_history from "./tabs/cont_email_history.vue";
import cont_comments from "./tabs/cont_comments.vue";
import cont_stata from "./tabs/cont_stata.vue";

export default {
    name: "contragent_info",
    
    components : {
        Company_info_field,
        BTabs,
        BOverlay,
        BTab,
        cont_vkursi,
        cont_subscribes,
        cont_email_history,
        cont_comments,
        cont_stata
    },
    
    props : {
        id : {
            type : Number,
            default : 0,
        }
    },
    
    data() {
        return {
            is_load : false,
            contragent : {},
            tabIndex : -1,
            tabId : "tender_general",
            tabs : []
        }
    },
    
    created() {
        this.getContragent();
    },
    
    methods : {
        
        tabTitle(tab) {
            if(tab.index === 'cont_comments') {
                tab.title = 'Коментарі ('+ this.contragent.messages.length + ')';
            }
            return tab.title;
        },
        
        async getContragent() {
            this.is_load = true;
            this.contragent = {};
            
            await api.get('/tenders/sales/tenders/contragents/' + parseInt(this.id)).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.contragent = data.data;
                    this.pushTabs();
                }
            }).catch(e => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        pushTabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    title       : item.title,
                    disabled    : item.disabled,
                    is_active   : item.is_active,
                    is_load     : false,
                    index       : item.index,
                });
            });
            
            this.contragent.messages = [];
            
        },
    },
    
    computed : {
        
        default_tabs() {
            
            let def = [
                {
                    "title": "Дані з реєстрів",
                    "index": "cont_vkursi",
                    is_active: true,
                    disabled: false,
                },
                {
                    "title": "Підписки",
                    "index": "cont_subscribes",
                    is_active: false,
                    disabled: false,
                },
                {
                    "title": "Emails ",
                    "index": "cont_email_history",
                    is_active: false,
                    disabled: false,
                },
                
                {
                    "title": "Коментарі",
                    "index": "cont_comments",
                    is_active: false,
                    disabled: false,
                },
                {
                    "title": "Аналіз контрагента ",
                    "index": "cont_stata",
                    is_active: false,
                    disabled: false,
                },
                
                
                
            ];
            
            return def;
        }
    }
}
</script>



<style scoped>

</style>